import React, { useContext, useEffect } from 'react';
import { Card, CardContent, Typography, IconButton, Grid, Modal, Button } from '@mui/material';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { MODALTEXTHEADING } from '../../constants';
import { CommercialModalStyles as classes } from './CommercialModalStyles';
import CloseIconIMG from '../../images/Icon.svg';

const CommercialModal = (props) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(true);
  const leadGenerationContext = useContext(LeadGenerationContext);
  const { vouchedModal, openModal, message, setFun } = props;
  const handleClose = () => {
    leadGenerationContext.setOpenProductQuestionModal(false);
    setOpen(false);
    if (!vouchedModal) {
      setFun(false);
    }
  };

  useEffect(() => {
    openModal ? setOpen(true) : setOpen(false);
  }, [openModal]);

  const textTwo = message;
  return (
    <Modal
      sx={classes.backdrop}
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(233, 233, 235, 0.78)',
        },
      }}
      role="dialog"
      aria-describedby="dialog1BusinessDesc dialog2BusinessDesc"
      open={open}
    >
      <div style={{ outline: 'none' }}>
        <Grid container style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <IconButton
            src={CloseIconIMG}
            name="closeicon"
            onClick={handleClose}
            tabIndex="0"
            data-testid="close_id"
            id="businessAddressEdit"
            disableRipple
            sx={classes.closeOverlay}
          >
            <img
              alt={t(`close`, { defaultValue: 'close' })}
              src={CloseIconIMG}
              width="20px"
              height="20px"
            />
          </IconButton>
        </Grid>
        <Grid container>
          <Card sx={classes.root}>
            <CardContent sx={classes.card_content}>
              {!leadGenerationContext.msgModal && (
                <>
                  {' '}
                  <Typography sx={classes.textOneStyle} id="dialog1BusinessDesc">
                    {t(MODALTEXTHEADING, { defaultValue: MODALTEXTHEADING })}
                  </Typography>{' '}
                </>
              )}
              {leadGenerationContext.msgModal && (
                <>
                  {' '}
                  <Typography sx={classes.textOneStyle} id="dialog1BusinessDesc">
                    {t('BusinessProductModalTextOneCommercial', { defaultValue: MODALTEXTHEADING })}
                  </Typography>{' '}
                </>
              )}
              <Typography sx={classes.textTwoStyle} id="dialog2BusinessDesc">
                {t(textTwo, { defaultValue: textTwo })}
              </Typography>
              <div style={{ width: '100%' }}>
                <Button
                  autoFocus
                  disableFocusRipple
                  sx={classes.saveAndExit}
                  data-testid="CloseButtonInBusinessModal"
                  onClick={handleClose}
                >
                  {t('Close', { defaultValue: 'Close' })}
                </Button>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </div>
    </Modal>
  );
};
export default withRouter(CommercialModal);

CommercialModal.propTypes = {
  setFun: PropTypes.func,
  openModal: PropTypes.func,
  message: PropTypes.string,
  vouchedModal: PropTypes.bool,
};
